<template>
  <v-tabs
    v-bind="$attrs"
    class="theme-tap-bar"
    :value="value"
    v-on="$listeners"
    @change="$emit('input', $event)"
  >
    <v-tab
      v-for="(tab, index) in tabs"
      :key="index"
      :class="{ 'active-tab': value === index }"
    >
      {{ tab }}
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "ThemedTapBar",
  inheritAttrs: false,
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    value: {
      type: Number,
      default: 0,
    },
  },
};
</script>

  <style scoped>
.theme-tap-bar {
  background-color: var(--color-surface) !important;
  border: 1px solid var(--color-border);
  overflow: hidden;
}

.theme-tap-bar ::v-deep .v-tabs-bar {
  background-color: transparent !important;
  height: 48px !important;
  padding: 0;
}

.theme-tap-bar ::v-deep .v-tab {
  color: var(--color-text-muted) !important;
  font-weight: 500;
  text-transform: none;
  letter-spacing: normal;
  transition: var(--transition-default);
  min-width: 0;
  padding: 0 16px;
}

.theme-tap-bar ::v-deep .v-tab.active-tab {
  color: var(--color-text) !important;
  background-color: var(--color-secondary) !important;
}

.theme-tap-bar ::v-deep .v-tab:hover:not(.active-tab) {
  color: var(--color-text) !important;
  background-color: var(--color-secondary-light) !important;
  opacity: 0.8;
}

.theme-tap-bar ::v-deep .v-tabs-slider {
  display: none;
}

/* Remove default tab indicator */
.theme-tap-bar ::v-deep .v-tabs-bar__content {
  border: none !important;
}

/* Ensure proper spacing in grow mode */
.theme-tap-bar ::v-deep .v-tabs-bar__content > .v-tab {
  flex: 1;
  justify-content: center;
}
</style>
